import { render } from "./broadcast.vue?vue&type=template&id=a6a9978e&scoped=true"
import script from "./broadcast.vue?vue&type=script&lang=js"
export * from "./broadcast.vue?vue&type=script&lang=js"

import "./broadcast.vue?vue&type=style&index=0&id=a6a9978e&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6a9978e"]])

export default __exports__